import { ReactComponent as InfoIcon } from "assets/icons/InfoIcon.svg";
import { ReactComponent as PencilSVG } from "assets/icons/pencil.svg";
import BottomArrowSvg from "assets/icons/svg/BottomArrowSvg";
import { CheckBox } from "components/CheckBox/CheckBox";
import { InputField } from "components/InputField/InputField";
import { getCurrency, numberFormat } from "helper/numberFormat";
import React, { useCallback, useMemo } from "react";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import Select, { components } from "react-select";

import PaymentInstallment from "components/PaymentInstallment/PaymentInstallment";
import {
  DataFoundWrapper,
  DataNotFoundWrapper,
  NumberOfSelections,
  PaymentAmount,
  PaymentInstallmentAmount,
  PaymentInstallmentCheckbox,
  PaymentInstallmentLeft,
  PaymentInstallmentSelection,
  PaymentInstallmentWrapper,
  SummaryItem,
  SummaryItemCharge,
  SummaryItemInfo,
  SummaryItemLedger,
  SummaryItemLeft,
  SummaryItemSubLedger,
  SummaryTitle,
  TotalDueAmount,
  TotalPayment,
  TotalPaymentEditBtn,
  TotalPaymentEditIcon,
  TotalPaymentField,
  TotalPaymentFieldSign,
  TotalPaymentLeftSide,
  Wrapper,
} from "./Theme";
import { FontWeights, FontColors } from "theme/fontConfig";
const regex = /([0-9]*[\.|\,]{0,1}[0-9]{0,2})/s;

const selectControlStyles = {
  color: FontColors.Slate3F4254,
  transition:
    "color 0.15s ease, background-color 0.15s ease, border-color 0.15s ease, box-shadow 0.15s ease",
  paddingTop: "6px",
  paddingBottom: "6px",
  cursor: "pointer",
};
const colourStyles = {
  control: (styles) => ({
    ...styles,
    ...selectControlStyles,
  }),
  menuList: (styles) => ({
    ...styles,
    maxHeight: "150px",
  }),
  menu: (styles) => ({
    ...styles,
    zIndex: 9999,
  }),
};

const formatOptionLabel = ({ label, _id }) => {
  return (
    <div className="dropdown-container" key={_id}>
      <div className="icon-name-container d-flex align-items-center justify-content-start">
        <div className="name-container" style={{ marginInlineStart: 10 }}>
          <div>{label}</div>
        </div>
      </div>
    </div>
  );
};

const DropdownIndicator = (props) => {
  return (
    <components.DropdownIndicator {...props}>
      <BottomArrowSvg label="Emoji" />
    </components.DropdownIndicator>
  );
};

const getInstallmentOptions = () => {
  // pattern 2 monthly installments, 3 monthly installments, ... 24 monthly installments
  let installmentOptions = [];
  for (let i = 2; i <= 24; i++) {
    installmentOptions.push({
      value: i,
      label: `${i} monthly installments`,
    });
  }
  return installmentOptions;
};

export const SummaryCard = ({
  chargeSelections,
  formik,
  setEditedTotalPayment,
  editedTotalPayment,
  calculateConvenienceFeeAmount,
  reverseCalculationConvenienceFee,
  calculationTotalPaymentWithCV,
  allowEditTotalPayment,
  calculationPayment,
  setChargeSelections,
  calculateDueAmount,
  dueAmountWithCF,
  isThereInstallmentPayment,
  isInstallmentEnabled,
  setActivePaymentAfter,
  currentPaymentMethod,
  activePayment,
  setConvenienceFeeByPayment,
  convenienceFeeByPayment,
}) => {
  const isMobile = useMediaQuery("(max-width:600px)");
  const currency = getCurrency();

  const [editTotalPayment, setEditTotalPayment] = React.useState(false);
  const totalDueAmount = useMemo(() => calculateDueAmount(), [
    calculateDueAmount,
  ]);
  const totalPaymentForCV = editedTotalPayment || totalDueAmount;
  const convenienceFeeAmount = useMemo(
    () => calculateConvenienceFeeAmount(totalPaymentForCV),
    [calculateConvenienceFeeAmount, totalPaymentForCV],
  );

  const onTotalPaymentChange = useCallback(
    (e) => {
      const { value } = e.target;
      const maxValue = value > calculationTotalPaymentWithCV();
      if (value < 1 || maxValue) {
        return;
      }
      formik.setFieldValue("totalPayment", value.match(regex)[0]);
    },
    [formik, calculationTotalPaymentWithCV],
  );
  const shouldShowConvenienceFeeToggle =
    currentPaymentMethod?.coverConvenienceFee;
  const isConvenienceFeeOptional =
    currentPaymentMethod?.convenienceFeeInfo?.optional === true;

  const onTotalPaymentBlur = useCallback(
    (e) => {
      const totalPayment = formik?.values?.totalPayment;

      const minValue =
        currentPaymentMethod?.convenienceFeeInfo?.type === "$"
          ? totalPayment <= currentPaymentMethod?.convenienceFeeInfo?.amount
          : totalPayment < 1;
      if (minValue &&convenienceFeeByPayment[activePayment]) {
        formik.setFieldValue(
          "totalPayment",
          currentPaymentMethod?.convenienceFeeInfo?.amount + +totalPayment,
        );
      }
	  else if( minValue && !convenienceFeeByPayment[activePayment]){
         formik.setFieldValue(
          "totalPayment",
          +totalPayment
        );
      }
      const totalWithoutConvenience = reverseCalculationConvenienceFee(
        totalPayment,
      );
      setEditedTotalPayment(totalWithoutConvenience);
      setEditTotalPayment(false);
    },
    [
      formik,
      currentPaymentMethod,
      reverseCalculationConvenienceFee,
      setEditedTotalPayment,
    ],
  );

  const editTotalPaymentHandler = useCallback(() => {
    setEditTotalPayment(true);
  }, []);

  const selectedInstallment = (item) => {
    return item?.installment || null;
  };

  const installmentsOptions = useMemo(() => getInstallmentOptions(), []);

  const calculateInstallmentAmount = (item) => {
    if (!item?.installmentStatus) return "";
    if (item?.installment?.value) {
      return numberFormat({
        number: +item?.amount / item?.installment?.value,
        decimal: 2,
        style: "currency",
      });
    }
    return "";
  };

  return (
    <Wrapper style={isMobile ? { padding: "16px 16px 0 16px", maxHeight: "none" } : undefined}>
      <SummaryTitle>
        <span>Summary</span>
      </SummaryTitle>
      {chargeSelections?.length === 0 ? (
        <DataNotFoundWrapper>
          <span>No payments were selected yet</span>
        </DataNotFoundWrapper>
      ) : (
        <DataFoundWrapper>
          <NumberOfSelections style={isMobile ? { marginBottom: "8px" } : undefined}>
            <span>{`You selected ${chargeSelections?.length} charges to pay`}</span>
          </NumberOfSelections>
          {chargeSelections?.map((item) => (
            <SummaryItem>
              <SummaryItemCharge>
                <SummaryItemLeft>
                  <SummaryItemInfo>
                    <SummaryItemLedger>{item?.Ledger?.name}</SummaryItemLedger>
                    <SummaryItemSubLedger>
                      {item?.SubLedger?.name}
                    </SummaryItemSubLedger>
                  </SummaryItemInfo>
                </SummaryItemLeft>
                <PaymentAmount>
                  {editedTotalPayment ? (
                    <del>{`${numberFormat({
                      number: +item?.amount,
                      decimal: 2,
                      style: "currency",
                    })}`}</del>
                  ) : (
                    <>{`${numberFormat({
                      number: +item?.amount,
                      decimal: 2,
                      style: "currency",
                    })}`}</>
                  )}
                </PaymentAmount>
              </SummaryItemCharge>
              {isInstallmentEnabled && item?.isInstallmentTransaction && (
                <PaymentInstallment
                  onAllowInstallmentChange={(e) => {
                    calculationPayment();
                    const updatedListItem = chargeSelections?.map((val) => {
                      if (val.chargeId === item.chargeId) {
                        return {
                          ...val,
                          installmentStatus: e.target.checked,
                          ...(!e.target.checked && { installment: null }),
                        };
                      }
                      return val;
                    });
                    setChargeSelections(updatedListItem);
                    setEditedTotalPayment(0);
                    setActivePaymentAfter();
                  }}
                  installmentValue={item?.installmentStatus || false}
                  onSelectInstallment={(value) => {
                    const updatedListItem = chargeSelections?.map((val) => {
                      if (val.chargeId === item.chargeId) {
                        return {
                          ...val,
                          installment: value,
                        };
                      }
                      return val;
                    });
                    setChargeSelections(updatedListItem);
                  }}
                  selectedInstallment={selectedInstallment(item)}
                  installmentAmount={calculateInstallmentAmount(item)}
                  maxInstallment={
                    item?.installmentDetailsTransaction?.numberOfInstallment
                  }
                />
              )}
            </SummaryItem>
          ))}
          {shouldShowConvenienceFeeToggle && (
            <SummaryItem>
              {/* {isConvenienceFeeOptional && (
                <div
                  className={`wrapper check-box__wrapper`}
                  style={{
                    display: "flex",
                    marginBottom: "10px",
                    marginTop: "10px",
                    color: "#002e5c",
                  }}
                >
                  <label className="check-box-container">
                    <input
                      type="checkbox"
                      style={{ marginRight: 8 }}
                      checked={convenienceFeeByPayment[activePayment]}
                      onChange={(e) => {
                        setConvenienceFeeByPayment((prev) => ({
                          ...prev,
                          [activePayment]: e.target.checked,
                        }));
                      }}

                      // disabled={disabled}
                      // {...rest}
                    />
                    <span className={"checkbox-checkmark"}></span>
                  </label>
                  <span className="text">
                    {currentPaymentMethod?.convenienceFeeInfo?.message}
                  </span>
                </div>
              )} */}
              {convenienceFeeByPayment[activePayment] && (
                <SummaryItemCharge>
                  <div>
                    <span>Convenience fee</span>
                  </div>
                  <PaymentAmount>
                    {numberFormat({
                      number: +convenienceFeeAmount,
                      decimal: 2,
                      style: "currency",
                    })}
                  </PaymentAmount>
                </SummaryItemCharge>
              )}
			       {isConvenienceFeeOptional && (
                    <div
                      style={{
                        marginTop: "10px",
                        paddingTop: "10px",
                        borderTop: "1px dashed rgba(0, 46, 92, 0.10)",
                        color: FontColors.Slate6B7280,
                      }}
                    >
                      <CheckBox
                        checked={convenienceFeeByPayment[activePayment]}
                        onChange={(e) => {
                          setConvenienceFeeByPayment((prev) => ({
                            ...prev,
                            [activePayment]: e.target.checked,
                          }));
                        }}
                        text={currentPaymentMethod?.convenienceFeeInfo?.message}
                      />
                    </div>
                  )}
            </SummaryItem>
          )}
          <TotalPayment>
            <p>Payment Total</p>
            {allowEditTotalPayment && editTotalPayment ? (
              <TotalPaymentField>
                <InputField
                  placeholder="Payment Total"
                  styleWrapper={{ width: "100%" }}
                  style={{
                    width: "100%",
                    paddingLeft: "20px",
                    paddingRight: "5px",
                    color: FontColors.Blue002E5C,
                    fontWeight: FontWeights.Medium,
                    lineHeight: "13px",
                    textAlign: "right",
                  }}
                  isOptional={false}
                  value={formik?.values?.totalPayment}
                  name="first_name"
                  handleChange={onTotalPaymentChange}
                  onBlur={onTotalPaymentBlur}
                />
                <TotalPaymentFieldSign>{currency}</TotalPaymentFieldSign>
              </TotalPaymentField>
            ) : (
              <TotalPaymentLeftSide>
                {allowEditTotalPayment && !isThereInstallmentPayment() && (
                  <TotalPaymentEditBtn onClick={editTotalPaymentHandler}>
                    Edit Amount
                    <TotalPaymentEditIcon>
                      <PencilSVG
                        style={{
                          width: 12,
                          height: 12,
                        }}
                      />
                    </TotalPaymentEditIcon>
                  </TotalPaymentEditBtn>
                )}

                <span>
                  {numberFormat({
                    number: +formik?.values?.totalPayment,
                    decimal: 2,
                    style: "currency",
                  })}
                </span>
              </TotalPaymentLeftSide>
            )}
          </TotalPayment>
          <TotalDueAmount>
            <p>Due Now</p>
            <span>
              {numberFormat({
                number: dueAmountWithCF,
                decimal: 2,
                style: "currency",
              })}
            </span>
          </TotalDueAmount>
        </DataFoundWrapper>
      )}
    </Wrapper>
  );
};
